var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"dark":"","flat":""}},[_c('v-text-field',{attrs:{"outlined":"","label":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.tableItems,"search":_vm.search},on:{"click:row":_vm.getSinglePoem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }